import React, { Component } from 'react';
// import { BrowserRouter } from 'react-router-dom'

import './styles/App.css'
import Header from './header'
import Body from './Body';
import Footer from './Footer';

class App extends Component {
render() {
    return (
      <div>
      <Header />
        <Body />
        <Footer/>
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js